import { normalizeName } from "../../searchprotocol"
import { INormalizedNameLUT } from "../../index"

export type ParsedElement = {
    asString: string
} & (
    | {
          type: "text"
          text: string
      }
    | {
          type: "semicolon"
      }
    | {
          type: "colon"
      }
    | {
          type: "keyValue"
          key: string
          value: string
      }
)
export function makeParsedElement(
    first: string,
    second?: string,
): ParsedElement {
    if (second === undefined) {
        switch (first) {
            case ";":
                return { type: "semicolon", asString: first }
            case ":":
                return { type: "colon", asString: first }
            default:
                return { type: "text", text: first, asString: first }
        }
    } else {
        return {
            type: "keyValue",
            key: first,
            value: second,
            asString: first + ":" + second,
        }
    }
}

export function parse(
    text: string,
    fieldLabels: INormalizedNameLUT,
): ParsedElement[] {
    const elements: ParsedElement[] = []
    const tokens = tokenize(text)
    let current, second

    while (tokens.length) {
        current = tokens.shift() as Token
        second = tokens[0]
        if (current.type == "text") {
            const firstChar = current.value[0]
            const hasPrefix = firstChar === "+" || firstChar === "-"
            const extracted = current.value.slice(hasPrefix ? 1 : 0)
            const normalized = normalizeName(extracted)
            if (normalized in fieldLabels && second?.type == "colon") {
                tokens.shift()
                elements.push(
                    makeParsedElement(
                        (hasPrefix ? firstChar : "") +
                            fieldLabels[normalized].original,
                        getValue(),
                    ),
                )
                continue
            }
        }
        elements.push(makeParsedElement(current.value))
    }

    return elements

    function getValue(): string {
        let current
        let builder = ""
        while (tokens.length) {
            current = tokens[0]
            if (current?.type !== "semicolon") {
                builder += current.value
                tokens.shift()
            } else {
                break
            }
        }
        return builder
    }
}

type Type = "text" | "semicolon" | "colon"
type Token = {
    type: Type
    value: string
}

function tokenize(text: string): Token[] {
    const tokens: Token[] = []
    const input = text.split("")
    let current
    let builder = ""

    while (input.length) {
        current = input.shift()
        if (current === '"') {
            builder += getQuoted()
            continue
        }
        if (current === ":" || current == ";") {
            builder && addToken("text", builder)
            builder = ""
            addToken(current == ":" ? "colon" : "semicolon", current)
            continue
        }
        builder += current
    }

    builder && addToken("text", builder)

    return tokens

    function getQuoted(): string {
        let result = ""
        let current
        while (input.length) {
            current = input.shift()
            if (current === '"') {
                return '"' + result + '"'
            }
            result += current
        }
        return '"' + result
    }

    function addToken(type: Type, value: string): void {
        tokens.push({ type, value: value.trimStart() })
    }
}
